import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import {version} from '../package';

import Vuelidate from "vuelidate";
import TokenService from "./services/storage.service.js";
import ApiService from "./services/api.service.js";
import S3Service from "./services/S3.service.js";
import LoadScript from "vue-plugin-load-script";
import vuetify from "@/plugins/vuetify"; // path to vuetify export
import "vuetify/dist/vuetify.min.css";

import config from '@/assets/js/config/Config';
window.config = config;

import VueTippy, { TippyComponent } from "vue-tippy";

// Form
import Form from "@/forms/Form.js";
Object.defineProperty(Vue.prototype, "Form", { value: Form });
window.Form = Form;

// Global Event Bus
const EventBus = new Vue();
Object.defineProperty(Vue.prototype, "$eventBus", { value: EventBus });

// Moment
import Moment from "moment";
Moment.updateLocale("en", {
	relativeTime: {
		s: "just now",
	}
})
Object.defineProperty(Vue.prototype, "Moment", { value: Moment });
window.Moment = Moment;

import $ from 'jquery';
window.jQuery = $;
window.$ = $;

// Lodash
import lodash from "lodash";
Object.defineProperty(Vue.prototype, "_", { value: lodash });

// Tensorflow
import * as tf from '@tensorflow/tfjs'
window.tf = tf;

Vue.prototype.APP_VESRION = version;
Vue.prototype.$tokenService = new TokenService();
Vue.prototype.$apiService = new ApiService(process.env.VUE_APP_API_URL);
Vue.prototype.$S3Service = new S3Service();
Vue.prototype.$ably = null;

window.API_URL = process.env.VUE_APP_API_URL;
window.APP_URL = process.env.VUE_APP_URL;
window.FYLM_LITE_APP_URL = process.env.VUE_APP_FYLM_LITE_URL;

Vue.use(LoadScript);
Vue.use(Vuelidate);

Vue.use(VueTippy, { placement: "top", arrow: true, arrowType: "sharp", animation: "fade", delay: [50, null] });
Vue.component("tippy", TippyComponent);

window.Vue = Vue;

const vm = new Vue({
	router,
	store,
	vuetify,
	render: h => h(App),
}).$mount("#app");

window.vm = vm;

export { vm };
